module.exports = __webpack_public_path__ + "img/logo-light.b104eeff.svg";